// UI-free so non-UI consumers can use these without pulling in @primer/react.
// User-facing labels/descriptions live with the picker that renders them.

export type AgentMode = 'interactive' | 'plan' | 'autopilot'

/** The mode the host applies when no override is sent. */
export const DEFAULT_AGENT_MODE: AgentMode = 'interactive'

export const AGENT_MODE_VALUES: AgentMode[] = ['interactive', 'plan', 'autopilot']

export function isAgentMode(value: unknown): value is AgentMode {
  return typeof value === 'string' && (AGENT_MODE_VALUES as string[]).includes(value)
}
